import createPromiseSaga from 'lib/createPromiseSaga';
import normalizingFetch from 'lib/normalizingFetch';
import { all, take, actionChannel } from 'redux-saga/effects';
import { SEARCH_SUGGESTIONS } from './actions';
import getIn from '@alexaivars/get-in/index';

function* watchSearchSuggestions() {
  const channel = yield actionChannel(SEARCH_SUGGESTIONS);
  while (true) {
    const action = yield take(channel);
    const locale = getIn(action, ['payload', 'locale']);
    yield* createPromiseSaga(
      action,
      normalizingFetch,
      `${process.env.REACT_APP_API_SEARCH_INIT}?locale=${locale}`,
      {
        detailedResponse: true,
        method: 'GET',
      },
    )();
  }
}

export default function* sagas() {
  yield all([watchSearchSuggestions()]);
}
